import type { GetStaticProps, NextPage } from "next";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";
import { SurveyPage } from "src/domains/shared/components/Home/Survey/SurveyPage";

const Survey: NextPage = () => (
  <SiteLayout>
    <SurveyPage />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default Survey;
